import { createContext, useContext, useLayoutEffect } from 'react';

export interface Guard {
  dirty: boolean;
  saving: boolean;
  save: () => Promise<boolean>;
}
export const UnsavedContext = createContext<{
  register: (guard: Guard | null) => void;
  request: (action: () => void) => void;
  navigationPending: boolean;
} | null>(null);

export function useGuardedAction() {
  const context = useContext(UnsavedContext);
  if (!context) throw new Error('UnsavedChangesProvider が必要です');
  return context.request;
}

export function useUnsavedChanges(guard: Guard): boolean {
  const context = useContext(UnsavedContext);
  if (!context) throw new Error('UnsavedChangesProvider が必要です');
  const { register } = context;
  useLayoutEffect(() => {
    register(guard);
  });
  useLayoutEffect(() => () => register(null), [register]);
  return context.navigationPending;
}
